<template>
  <md-toolbar class="md-dense">
    <div class="md-toolbar-section-start">
      <span>{{ L($route.name) | upper }}</span>
    </div>
    <div class="md-toolbar-section-end">
      <slot></slot>
    </div>
  </md-toolbar>
</template>

<script>
import { changePath } from '@/lib/textutil'

export default {
  methods: {
    L(path) {
      const changePathText = changePath(path)

      return this.$te(changePathText)
        ? this.$t(changePathText)
        : this.$t(`menu.${path}`)
    },
  },
}
</script>

<style lang="scss" scoped>
.md-toolbar-section-start {
  flex: 0.2;
}

.md-toolbar-section-end {
  flex: 0.8;
  &::v-deep .search-field {
    max-width: 30%;
  }
}
</style>
